import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';

import { Mensaje, MensajeSiNo } from '../../../mensajes2';
import { Dimmer } from '../../../spinner';
import useTable from '../../../useTable';
import { Toasts } from '../../../toasts';

import { Input } from '../../../../ui/inputs/Input';
import { PrimaryButton } from '../../../../ui/buttons/Button';
import GruposNominas from './GruposNominas'; // Ajusta la ruta según donde guardes el modal

const TablaGrupoNomina = (props) => {
    var op = require('../../../../modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const [mostrar, setMostrar] = useState(false);
    const [id, setId] = useState(0);
    const [operacionModal, setOperacionModal] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [idModal, setIdModal] = useState('');

    // Definir los headCells para UNIDAD FUNCIONAL
    const headCells = [
        { id: 'codgru', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CÓDIGO', textAlign: 'center' },
        { id: 'nomgru', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE', textAlign: 'center' },
        { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' }
    ]

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const txtBuscador = useRef();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const permiso = JSON.parse(localStorage.getItem('accdepartamento')) || JSON.parse(localStorage.getItem('accbanco'));
    const [toast, setToast] = useState({
        mostrar: false,
        mensaje: '',
        titulo: ''
    })

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                const query = target.value.toLowerCase();
                if (query === "") return items;

                return items.filter(x =>
                    (x.codgru?.toString().toLowerCase().includes(query)) ||
                    (x.nomgru?.toLowerCase().includes(query))
                );
            }
        });
    };

    const seleccionarRegistros = () => {
        let codigoNomina = localStorage.getItem('codigonomina');
        codigoNomina = codigoNomina ? codigoNomina.replace(/"/g, '') : '';

        let campos = "*";
        let nomtab = `nomi${codigoNomina}.gruposnomina`;
        let condi = props.condicion ? props.condicion : " 1=1 ";
        let orden = "codgru";
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    console.log('Grupo de Nominas cargados:', response.data);
                    setRecords(response.data);
                }
                setActivate(false);
            })
            .catch(function (error) {
                setMensaje({ 
                    mostrar: true, 
                    titulo: 'Error', 
                    texto: error.response?.data?.message || error.message, 
                    icono: 'error' 
                });
                setActivate(false);
            });
    };

    const cerrarToast = () => {
        setToast({
            ...toast,
            mostrar: false
        })
    }

    const gestionarUnidad = (op, id) => (e) => {
        if (e) e.preventDefault();
        setOperacionModal(op);
        if (op !== 1) {
            setIdModal(id);
        } else {
            setIdModal('');
        }
        setShowModal(true);
    }

    const recargarTabla = () => {
        seleccionarRegistros();
    }

    const handleCloseSi = () => {
        setActivate(false);
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
    };

    useEffect(() => {
        seleccionarRegistros();
    }, []);

    const cerrar = () => {
        if (props.setTabla) {
            props.setTabla(0);
        }
    }

    // Formatear código a 3 dígitos para mostrar
    const formatearCodigo = (codigo) => {
        if (!codigo) return '';
        return codigo.toString().padStart(3, '0');
    };

    // Función para cerrar el modal y recargar la tabla si es necesario
    const handleCloseModal = () => {
        setShowModal(false);
        setIdModal('');
        setOperacionModal(1);
        // Recargar la tabla después de cerrar el modal
        seleccionarRegistros();
    };

    return (
        <section className='col-8 m-0 p-0'>
            <header className='col-12 m-0 px-4 py-2 rounded-top d-flex align-items-center justify-content-between azulGradiant text-light'>
                <h3 className='m-0'>
                    Gestión de Unidades Funcionales
                </h3>
                <a type='button' onClick={cerrar} className="text-light" style={{ cursor: 'pointer' }}>
                    Salir <i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e) => { e.preventDefault() }} className="d-flex justify-content-between p-2">
                <div className='col-4 m-0 p-0'>
                    <Input 
                        type="text"
                        ref={txtBuscador}
                        onChange={handleSearch}
                        placeholder="Buscar por código o nombre" 
                        inputClassName='rounded-pill'
                    />
                </div>
                <PrimaryButton 
                    icon='fa-plus m-0'
                    disabled={permiso?.toString().substring(1, 2) !== '1'}
                    onClick={gestionarUnidad(1, '')}
                    title='Agregar Unidad Funcional'
                >
                    Agregar Unidad Funcional
                </PrimaryButton>
            </form>
            <div className="">
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center" }}>
                                        {formatearCodigo(item.codgru)}
                                    </td>
                                    <td className='align-baseline' style={{ textAlign: "left" }}>
                                        {item.nomgru}
                                    </td>
                                    <td className='align-baseline' style={{ textAlign: "center" }}>
                                        <button 
                                            onClick={gestionarUnidad(4, item.codgru)} 
                                            className={permiso?.toString().substring(0, 1) === '1' ? 'btn btn-sm btn-info rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Consultar"
                                            disabled={permiso?.toString().substring(0, 1) !== '1'}
                                        >
                                            <i className="fas fa-eye"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarUnidad(2, item.codgru)} 
                                            className={permiso?.toString().substring(2, 3) === '1' ? 'btn btn-sm btn-warning rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Editar"
                                            disabled={permiso?.toString().substring(2, 3) !== '1'}
                                        >
                                            <i className="fa fa-edit"></i>
                                        </button>
                                        {' '}
                                        <button 
                                            onClick={gestionarUnidad(3, item.codgru)} 
                                            className={permiso?.toString().substring(3, 4) === '1' ? 'btn btn-sm btn-danger rounded-circle' : 'btn btn-sm btn-secondary rounded-circle'}
                                            title="Eliminar"
                                            disabled={permiso?.toString().substring(3, 4) !== '1'}
                                        >
                                            <i className="fa fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>

            {/* Modal de GruposNominas */}
            <GruposNominas 
                show={showModal}
                setShow={setShowModal}
                setTabla={handleCloseModal}
                operacion={operacionModal}
                id={idModal}
            />

            <Dimmer active={activate} inverted></Dimmer>
            <Mensaje 
                mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} 
            />
            <MensajeSiNo 
                mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} 
                onHideSi={handleCloseSi} 
            />
            <Toasts
                show={toast.mostrar}
                titulo={toast.titulo}
                mensaje={toast.mensaje}
                onHideCancela={cerrarToast} 
            />
        </section>
    );
}

export default TablaGrupoNomina;